// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3EsoQ","validationTips":"StatementDescriptor_validationTips__2LWGc"};